module.exports = __webpack_public_path__ + "static/media/article4sqr.f6c39af9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article4sqr.jpeg
// module id = 97
// module chunks = 0